import { combineReducers } from 'redux';
import profile from './profile';
import { StateProfilePublicType } from './types';

const reducer = combineReducers<StateProfilePublicType>({ profile });

export default reducer;
